export default {
  list: {
    name: "delivery zones list api",
    version: 6,
    url: "delivery-zones",
    method: "GET",
  },
  add: {
    name: "add delivery zone api",
    version: 6,
    url: "delivery-zones",
    method: "POST",
  },
  update: {
    name: "update delivery zone api",
    version: 6,
    url: "delivery-zones/%{id}",
    method: "PUT",
  },
  delete: {
    name: "delete delivery zone api",
    version: 6,
    url: "delivery-zones/%{id}",
    method: "DELETE",
  },
};
